import React, { useEffect, useState } from "react";
import axios from "axios";

// Import hooks
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate} from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Star, StarFill, StarHalf } from "react-bootstrap-icons";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import "./MyClubs.css"

export default function MyClubs() {
  const [loading, setLoading] = useState(true);
  const [clubs, setClubs] = useState([]);
  const { user,dispatch } = useAuthContext();
  const navi = useNavigate();

  const fetchData = async () => {
    setLoading(true);
  
    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/clubs?OwnerId=${user.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setClubs(response.data);

      
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error('Error fetching clubs:', error);
    } finally {
      setLoading(false); // Stop loading regardless of success or error
    }
  };
  

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);


  if(loading){
    return(
      <div>
        <LoadingSpinner />
      </div>
    )
  }
else{
  return (
    <div className="container">
<div className="blueBanner">
<p className="fw-bold p-2">My Clubs</p>
</div>


{clubs.length == 0 && <div className="noClubs text-center bg-white mt-0">
  <p className="pt-3">
    You don't have any club profiles on this platform. If you are a club owner and would like to create a club page with Membotic, you can do so by visiting the Create a Club page.
  </p>

  <button onClick={() => navi("/CreateClub")} className="saveChanges-button">Create a Club</button>
</div>}


      <div className="row">
        {clubs.map((club) => {
          const { starsAverage = 0, starsCount = 0 } = club; // Default to 0 if undefined
          const fullStars = Math.floor(starsAverage);
          const hasHalfStar = starsAverage % 1 !== 0; // Check if there's a half star
          const totalReviews = starsCount;

          return (
            <div
              key={club.id}
              onClick={() => navi(`/myoneclub/${club.id}`)}
              className="search-club-container mx-2 my-3 d-flex flex-column justify-content-between"
            >
              <div>
                <div className="d-flex justify-content-center">
                  <div className="search-circle-crop mt-3">
                    <img
                      src={
                        club.hasImage
                          ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                          : NoImagePlaceholder
                      }
                      alt="Club Image"
                    />
                  </div>
                </div>
                <div className="text-center">
                  <p className="fontSize20 mt-2 mb-0 fw-bold">{club.name}</p>
                  <p className="fw-bold mb-0">
                    {club.city}, {club.county}
                  </p>
 
                  <div className="d-flex justify-content-center">
                    <hr className="w-25" />
                  </div>
                  <p className="mb-0">{club.subtitle.substring(0, 120)}</p>
           
                  <div className="d-flex justify-content-center">
                    <hr className="w-25" />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center pointer mt-auto">
                {[...Array(5)].map((_, index) => {
                  if (index < fullStars) {
                    return <StarFill key={index} />;
                  } else if (index === fullStars && hasHalfStar) {
                    return <StarHalf key={index} />;
                  } else {
                    return <Star key={index} />;
                  }
                })}
                <p className="mx-2 mt-4">
                  {starsAverage.toFixed(1)} • {totalReviews} reviews
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
}